import {ImageRequestParams} from "../models/image/image-request-params";
export class CloseImageRequestParams extends ImageRequestParams {
  constructor(width: Number, height: Number) {
    super({width, height});

    this._resourceName = `bolao26/Icons/Close_Icon`;
  }
}
